import { useForm } from '@mantine/form';
import { randomId } from '@mantine/hooks';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { i18nKeys, useTranslation } from 'locales';
import type { AmlFormValues } from '../types/types';

export function useAmlForm() {
  const { t } = useTranslation();
  const company = useCompanyConfiguration();

  const address = company?.address;
  const registeredOfficePreFill = address
    ? `${address.street_name} ${address.street_number}, ${address.zip_code} ${address.city}`
    : '';

  return useForm<AmlFormValues>({
    initialValues: {
      caseName: '',
      companyName: company?.name ?? '',
      vatNumber: company?.vat_number ?? '',
      registeredOffice: registeredOfficePreFill,
      directors: [{ key: randomId(), name: '', canBind: false }],
      listedCompany: false,
      beneficialOwners: [{ key: randomId(), name: '' }],
      lastName: '',
      firstName: '',
      address: '',
      mobile: '',
      email: '',
      nationalNumber: '',
      relationOrigin: t(i18nKeys.AML_MODAL.ADDITIONAL_INFO.PLACEHOLDERS.RELATION_ORIGIN),
      serviceDescription: t(i18nKeys.AML_MODAL.ADDITIONAL_INFO.PLACEHOLDERS.SERVICE_DESCRIPTION),
      pep: 'false',
      pepDetails: '',
    },
  });
}
